import { inject, Injectable } from '@angular/core';
import { MatLegacyDialog, MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { ScriptBlockDialogComponent } from '@shared/components/script-block-dialog/script-block-dialog.component';

@Injectable({ providedIn: 'root' })
export class ScriptBlockDetectionService {
  private dialog = inject(MatLegacyDialog);

  check() {
    setTimeout(() => {
      if (this.checkIntercomBlocked() || this.checkProductFruitsBlocked()) {
        this.showAdblockPopup();
      }
    }, 3000);
  }

  private checkIntercomBlocked(): boolean {
    return typeof (window as any).Intercom === 'undefined';
  }

  private checkProductFruitsBlocked(): boolean {
    return typeof (window as any).productFruits === 'undefined';
  }

  private showAdblockPopup() {
    this.dialog.open(ScriptBlockDialogComponent, {
      width: '400px',
    });
  }
}
